module.exports = __webpack_public_path__ + "static/media/male.90750103.gif";